import {useMutation} from 'react-query';
import {deleteAdvertisment} from '.';
import {AxiosError} from 'axios';
import {toast} from 'react-toastify';
import {useNavigate} from 'react-router-dom';
interface IUseDeleteMyAdvertismentProps {
  refetch?: () => void;
  filter: string;
}
const useDeleteMyAdvertisment = ({
  refetch,
  filter,
}: IUseDeleteMyAdvertismentProps) => {
  const navigate = useNavigate();

  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (guid: string) => {
      return deleteAdvertisment(guid, filter);
    },
    onSuccess: () => {
      refetch && refetch();
      toast.success('آگهی شما با موفقیت حذف شد');
      navigate('/my-store-advertisement');
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });
  return {isLoading, mutate, isSuccess};
};

export default useDeleteMyAdvertisment;
